import { render, staticRenderFns } from "./ZCcunliangzichanxingzhizhanbi2.vue?vue&type=template&id=8b430874&scoped=true"
import script from "./ZCcunliangzichanxingzhizhanbi2.vue?vue&type=script&lang=js"
export * from "./ZCcunliangzichanxingzhizhanbi2.vue?vue&type=script&lang=js"
import style0 from "./ZCcunliangzichanxingzhizhanbi2.vue?vue&type=style&index=0&id=8b430874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b430874",
  null
  
)

export default component.exports